<p-tree
  [(selection)]="selection"
  [ariaLabel]="'CHOP.MASSNAHMEN' | translate"
  [filter]="true"
  [propagateSelectionDown]="true"
  [propagateSelectionUp]="true"
  [value]="treeNodes"
  [virtualScroll]="true"
  [virtualScrollItemSize]="36"
  filterBy="label"
  scrollHeight="65vh"
  selectionMode="checkbox"></p-tree>
<div class="mt-4 flex justify-end gap-2">
  <p-button
    (onClick)="cancel()"
    [label]="'ACTIONS.CANCEL' | translate"
    [outlined]="true"
    severity="secondary"></p-button>
  <p-button
    (onClick)="onSubmit()"
    [disabled]="submitting || selection.length === 0"
    [label]="'ACTIONS.SAVE' | translate"></p-button>
</div>
